module.exports = __webpack_public_path__ + "img/product-p8_pic@2x.80fe0217.png";